import { markRaw } from '@vue/compat';

function defaultPlaylistOpen() {
    if (typeof window === 'undefined') {
        return true;
    }
    return window.innerWidth > 900;
}

/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data(){
        return {
            data:'',
            videos:[],
            user:'',
            player:null,
            videoIndex:0,
            post_id:qk_global.post_id,
            url:'',
            videoList:[],
            allowList:[],
            listStyle:true,
            preview:false,
            playerReady:false,
            playlistOpen:defaultPlaylistOpen(),
        };
    },
    computed:{
        showPlayerMask() {
            if (this.preview) return false;
            if (!this.videos.length) return true;
            return !this.isVideoAllowed(this.videoIndex);
        },
        hasPlaylist() {
            return this.videoList.length > 1;
        },
    },
    mounted(){
        if(!document.getElementById('moeplayer')) return;

        try {
            const saved = localStorage.getItem('videoListStyle');
            this.listStyle = saved ? JSON.parse(saved) : true;
        } catch (e) {
            this.listStyle = true;
        }

        try {
            const savedOpen = localStorage.getItem('videoPlaylistOpen');
            if (savedOpen !== null) {
                this.playlistOpen = savedOpen === '1';
            } else {
                this.playlistOpen = defaultPlaylistOpen();
            }
        } catch (e) {
            this.playlistOpen = defaultPlaylistOpen();
        }

        this.$http.post(qk_rest_url+'getVideoList','post_id='+this.post_id).then(res=>{
            this.data = res.data;
            this.videos = res.data.list || [];
            this.videoList = this.convertDataToVideoList(this.videos);
            this.user = res.data.current_user || {};
            this.allowList = this.user.allowList || [];

            if(!this.videoList.length) return;

            const player = markRaw(new MoePlayer({
                container: document.getElementById('moeplayer'),
                autoplay:true,
                autonext:this.videoList.length > 1,
                theme:"var(--theme-color)",
                videoList:this.buildPlayerVideoList(),
                videoIndex:this.videoIndex,
                danmaku: {
                    id: qk_global.post_id,
                    sendApi: qk_rest_url + 'sendDanmaku',
                    getApi: qk_rest_url + 'getDanmaku',
                },
            }));

            this.player = player;

            player.on('switchVideo', (i)=>{
                this.videoIndex = i;
                this.clearPlayerToast(player);
                this.applyPreviewState();
            });

            if(this.user.free_video) {
                player.toast.add(`
                    <div class="title">您正在享受会员免费观看视频特权</div>
                    <div class="desc">今日剩余免费观看 `+(this.user.free_count >= 9999 ? '不限' : this.user.free_count)+` 次</div>`
                ,10000);
            }

            player.on('loadedmetadata', () => {
                this.applyPreviewState();
            });

            this.playerReady = true;
            this.bindPlaylistClicks();
            this.applyPreviewState();
        }).catch((err) => {
            qkShowApiError(err, '加载视频失败');
        });
    },
    methods:{
        getRootEl() {
            const el = this.$el;
            if (el && typeof el.querySelector === 'function') {
                return el;
            }
            return document.getElementById('qk-player-wrap');
        },
        clearPlayerToast(player) {
            if (!player?.toast) return;
            if (typeof player.toast.clear === 'function') {
                player.toast.clear();
            } else if (player.toast.container) {
                player.toast.container.innerHTML = '';
            }
        },
        isVideoAllowed(index) {
            if (!this.allowList.length) return true;
            const allowed = this.allowList[index];
            return allowed === true || allowed === 1 || allowed === '1';
        },
        bindPlaylistClicks() {
            if (this._playlistBound) return;

            const root = this.getRootEl();
            if (!root || typeof root.addEventListener !== 'function') return;

            this._playlistBound = true;
            root.addEventListener('click', (event) => {
                const target = event.target.closest('[data-video-index]');
                if (!target || !root.contains(target)) return;

                event.preventDefault();
                event.stopPropagation();

                const index = parseInt(target.getAttribute('data-video-index'), 10);
                if (Number.isNaN(index)) return;

                this.playAtIndex(index);
            });
        },
        playAtIndex(index) {
            if (index < 0 || index >= this.videoList.length) return;
            if (!this.player) return;

            if (index === this.videoIndex) {
                this.restartCurrentVideo();
                return;
            }

            this.videoIndex = index;
            this.preview = false;

            this.clearPlayerToast(this.player);

            this.player.videoList = this.buildPlayerVideoList();
            this.player.videoIndex = index;
            this.player.loadVideo(true);
            this.player.playlist?.update();
            this.player.emit('switchVideo', index);
            this.applyPreviewState();
        },
        switchVideo(video,index){
            this.playAtIndex(index);
        },
        restartCurrentVideo() {
            const player = this.player;
            if (!player?.video) return;

            player.video.currentTime = 0;
            if (player.poster) player.poster.style.display = 'none';
            player.play();
        },
        buildPlayerVideoList() {
            return this.videoList.map((video, index) => {
                const allowed = this.isVideoAllowed(index);
                return {
                    id: video.id,
                    url: allowed ? (video.url || '') : '',
                    preview_url: video.preview_url || '',
                    pic: video.pic,
                    title: video.title,
                    link: video.link,
                };
            });
        },
        applyPreviewState() {
            const player = this.player;
            if (!player || !this.videoList.length) return;

            const current = this.videoList[this.videoIndex];
            if (!current) return;

            if (current.preview_url && !this.isVideoAllowed(this.videoIndex)) {
                this.preview = true;

                player.off('ended');
                player.on('ended', () => {
                    this.preview = false;
                });

                player.toast.add(`
                    <div class="prompt-bar-container">
                        <div>
                            <div class="title">本片是限制内容</div>
                            <div class="desc">试看中 · <span onclick="createModal('vip',{size:720})" style=" cursor: pointer; ">成为会员</span> 免费看本片</div>
                        </div>
                        <div class="action-wrap">
                            <div class="button" onclick="playerWrap.changePreview()">完整观看</div>
                        </div>
                    </div>
                `,9e6);
            }
        },
        pay(allpay) {
            if(!qktoken && !this.isVideoAllowed(this.videoIndex) && !this.user.not_login_pay && this.user.type == 'money'){
                this.login();
            }else if(!this.isVideoAllowed(this.videoIndex)){
                if(this.user.type == 'credit' || this.user.type == 'money'){
                    if(!allpay) {
                        qkpay({
                            'title': this.videoList[this.videoIndex].title,
                            'order_price': this.user.value,
                            'order_type':'video',
                            'order_key':this.videoIndex,
                            'post_id':this.data.id,
                            'type':this.user.type,
                            'tag':'付费视频'
                        },this.user.type)
                    }else{
                        qkpay({
                            'title': this.data.title,
                            'order_price': this.user.total_value,
                            'order_type':'video',
                            'post_id':this.data.id,
                            'type':this.user.type,
                            'tag':'付费视频'
                        },this.user.type)
                    }

                }else if(this.user.type == 'password') {
                    this.$createModal('passwordVerify',{
                        size:312,
                        loading:false,
                        props:{
                            data:qk_global.password_verify
                        },
                    })
                }else{
                    this.$message({ message: '您无权观看，请升级权限！' , type: 'warning' });
                }
                return
            }
        },
        login(){
            if(!qktoken) return this.$createModal('login');
        },
        changeListStyle() {
            this.listStyle = !this.listStyle;
            localStorage.setItem('videoListStyle', JSON.stringify(this.listStyle));
        },
        togglePlaylistDrawer() {
            this.playlistOpen = !this.playlistOpen;
            try {
                localStorage.setItem('videoPlaylistOpen', this.playlistOpen ? '1' : '0');
            } catch (e) {
                /* ignore */
            }
        },
        changePreview() {
            this.preview = false;
            this.player?.pause();
        },
        getFlatIndex(chapterIndex, itemVideoIndex) {
            let flat = 0;
            for (let i = 0; i < chapterIndex; i++) {
                if (this.videos[i] && Array.isArray(this.videos[i].video_list)) {
                    flat += this.videos[i].video_list.length;
                }
            }
            return flat + itemVideoIndex;
        },
        getEpisodeNumber(chapterIndex, videoIndex) {
            let episodeNumber = 1;
            for (let i = 0; i < chapterIndex; i++) {
                episodeNumber += this.videos[i].video_list.length;
            }
            episodeNumber += videoIndex;
            return episodeNumber;
        },
        convertDataToVideoList(data) {
            let videoList = [];

            if (data && Array.isArray(data)) {
                data.forEach(item => {
                    if (item && item.video_list && Array.isArray(item.video_list)) {
                        item.video_list.forEach(video => {
                            videoList.push({
                                id: video.id,
                                url: video.url || '',
                                preview_url: video.preview_url || '',
                                pic: video.pic || video.thumb || '',
                                title: video.title || '',
                                link: video.link || '',
                            });
                        });
                    }
                });
            }

            return videoList;
        }
    }
};
